import React from 'react';
import IntlMessage from "../../../../../../../helpers/intlMessage";

import Td from './Td';

const Table = ({ item }) => (
  <table style={{ width: '100%', marginBottom: '7px' }}>
    <tbody>
      <tr>
        <Td title={<IntlMessage id = "dashboards.reports.doctor"/>} value={item.medico} styleTd={{ width: '200px' }} />
        <Td
          title={<IntlMessage id = "dashboards.reports.phone"/>}
          value={item.telefone}
          styleTd={{ width: '200px' }}
        />
        <Td title={<IntlMessage id = "dashboards.disposalMaterials.user"/>} value={item.usuario} styleTd={{ width: '200px' }} />
        <Td
          title={<IntlMessage id = "general.requestsPanel.date"/>}
          value={item.dataCadastro}
          styleTd={{ width: '200px' }}
        />
      </tr>
      <tr>
        <Td colSpan='4' title={<IntlMessage id = "dashboards.reports.notification"/>} value={item.notificacao} />
      </tr>
    </tbody>
  </table>
);

export default Table;



// WEBPACK FOOTER //
// ./src/pages/relatorio/LaudoCritico/Relatorios/Notificacao/Impressao/Table/index.js